/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Range_ToInputs */

const cs_calendar_range_to = /** @type {(inputs: Calendar_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do`)
};

const en_calendar_range_to = /** @type {(inputs: Calendar_Range_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Calendar_Range_ToInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_range_to = /** @type {((inputs?: Calendar_Range_ToInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Range_ToInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_range_to(inputs)
	return cs_calendar_range_to(inputs)
});